import { Button, Col, Row } from "react-bootstrap"
import { InputSelect } from "../../../shared/Components/ElementInputsCostume"
import { AdapterGenerico } from "../../../shared/Infraestructure/AdapterGenerico"
import { useDispatch } from "react-redux";
import { changeGranFamiliaItem } from "../Domain/SliceStockPersonalTotal";
import { useSelector } from "react-redux";
import { RootState } from "../../../shared/Infraestructure/AdapterStore";

export function Filter() {
    const dispatch = useDispatch()
    const { granFamiliaItem } = useSelector((state: RootState) => state.stockPersonalTotal);
    const dataGranFamiliaItem = [
        {
            label: 'MATERIAL WAOO',
            value: 'MATERIAL WAOO'
        },
        {
            label: 'MATERIAL WIN',
            value: 'MATERIAL WIN'
        },
        {
            label: 'MATERIAL TUVES',
            value: 'MATERIAL TUVES'
        },
        {
            label: 'SOMACYLL',
            value: 'SOMACYLL'
        },
        {
            label: 'MATERIAL MIFIBRA',
            value: 'MATERIAL MIFIBRA'
        },
        {
            label: 'MATERIAL FIBRAMAS',
            value: 'MATERIAL FIBRAMAS'
        },
        {
            label: 'MATERIALES BANTEL',
            value: 'MATERIALES BANTEL'
        },
        {
            label: 'MATERIAL CLARO',
            value: 'MATERIAL CLARO'
        },
    ]

    return (
        <div>
            <Row>
                <InputSelect
                    values={{ granFamiliaItem }}
                    label='Gran Familia'
                    name='granFamiliaItem'
                    onChange={async (name, value) => {
                        try {
                            dispatch(changeGranFamiliaItem(value));
                        } catch (error) {
                            console.error(error)
                            AdapterGenerico.createMessage('Alerta', (error as Error).message, 'error')
                        }
                    }}
                    options={dataGranFamiliaItem.map(el => ({
                        label: el.label,
                        value: el.value,
                        dataComplete: el
                    }))}
                    disabledVirtualized
                />
            </Row>
            <Row style={{ display: granFamiliaItem.value.length ? 'block' : 'none' }}>
                <Col>
                    <Button
                        className='w-100'
                        onClick={() => {
                            try {
                                dispatch(changeGranFamiliaItem({ label: '', value: '', dataComplete: { label: '', value: '' } }));
                            } catch (error) {
                                console.error(error)
                                AdapterGenerico.createMessage('Alerta', (error as Error).message, 'error')
                            }
                        }}
                        variant={'danger'}
                    >
                        {'Limpiar Filtro'}
                    </Button>
                </Col>
            </Row>
        </div>
    )
}